/* 
 *  Created by RRamireddygari 02/14/2018
 */

import { Injectable } from '@angular/core';
import { BI_HttpService } from '../../services/http.service';
import { ConfigConstants } from '~config/util/config.constant';


@Injectable()
export class SyncwithcognosService {



  constructor(private http: BI_HttpService) {
  }

  synWithCognos() {
    return this.http.get(ConfigConstants.BI_SYNC_WITH_COGNOS_URL);
  }



}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/services/syncwithcognos.service.ts